define.alias("shared/components/shared/addon-details-card/upcoming-plan", "settings/components/shared/addon-details-card/upcoming-plan");